<link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
<!-- <app-header #header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<div class="wrapper">
    <div class="main">
        <div class="Refresh-button">
            <span class="title">Refresh Employee Details</span>
            <button class="button" (click)="uploadOfEmployees()">Refresh</button>
        </div>
        <div class="vertical-line"></div>
        <div class="competency-upload">
            <span class="title">Competency Bulk Upload</span>
            <div class="icons">
                <div class="download">
                    <button class="button" (click)="downloadSample()"> Download <span class="material-symbols-outlined">
                            download</span></button>
                </div>
                <div class="upload">
                    <input type="file" accept=".xlsx" (change)="onFileSelected($event)">
                    <button class="button" [disabled]="!file" [class.disabled-button]="!file"
                        (click)="uploadCompetencyExcelFile()"> Upload <span class="material-symbols-outlined">
                            upload</span></button>
                </div>
    
            </div>
    
        </div>
    
        <div class="vertical-line"></div>
    
        <div class="competency-upload">
            <span class="title">Country Bulk Upload</span>
            <div class="icons">
                <div class="download">
                    <button class="button" (click)="downloadCountrySample()"> Download <span
                            class="material-symbols-outlined"> download</span></button>
                </div>
                <div class="upload">
                    <input type="file" accept=".xlsx" (change)="onFileSelected($event)">
                    <button class="button" [disabled]="!file" [class.disabled-button]="!file"
                        (click)="uploadCountryExcelFile()"> Upload <span class="material-symbols-outlined">
                            upload</span></button>
                </div>
    
            </div>
    
        </div>
    
        <div class="vertical-line"></div>
    
        <div class="competency-upload">
            <span class="title">EmployeeStatus Bulk Upload</span>
            <div class="icons">
                <div class="download">
                    <button class="button" (click)="downloadEmployeeStatusSample()"> Download <span
                            class="material-symbols-outlined"> download</span></button>
                </div>
                <div class="upload">
                    <input type="file" accept=".xlsx" (change)="onFileSelected($event)">
                    <button class="button" [disabled]="!file" [class.disabled-button]="!file"
                        (click)="uploadEmployeeExcelFile()"> Upload <span class="material-symbols-outlined">
                            upload</span></button>
                </div>
            </div>
    
        </div>
    </div>
</div>